import React from "react";
import ListItem from "./ListItem";
import List from "../../../../components/List/List";
import styles from "./StandardBoardsList.module.scss";
import { connect } from "react-redux";
import { parseEnumStart } from "../../../../utils/utils";
import IoBoardListItem from "../../IoConfig/IoBoards/IoBoardListItem";

type StateProps = {
  ioConfig: State.IoConfig;
};

type StandardBoardsListProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[];
  parent: string;
  child: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onNodeSelect: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onRevisionClick: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onNodeEditClick?: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onBoardTypeClick: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onBoardEditClick: Function;
};

const StandardBoardsList = (props: StandardBoardsListProps & StateProps) => {
  const {
    rows,
    onNodeSelect,
    onRevisionClick,
    onBoardTypeClick,
    onBoardEditClick,
    ioConfig
  } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const boardTypes = Object.keys(rows)
  .sort( (a, b) => a > b ? 1 : -1 )
  .map((key: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const boardType = rows[key as any];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let revisions: any;
    if (ioConfig.openedRows.standardBoardTypes.includes(key)) {
      revisions = boardType
      .sort( (a:Api.StandardBoard, b:Api.StandardBoard) => a.revision > b.revision ? 1 : -1 )            
      .map((board: Api.StandardBoard) => {
        let nodesHolder;
        if (ioConfig.openedRows.standardBoards.includes(board.id)) {
          const nodes = board.standardNodes;
          nodesHolder = (
            <div key={board.id}>
              <IoBoardListItem
                title=""
                nodes={nodes}
                onRowItemClick={onNodeSelect}
                selectedNodeId={ioConfig.selectedStandardBoard.standardNodeId}
                onBoardEditClick={() => onBoardEditClick(board.id)}
              />
            </div>
          );
        }
        return (
          <div key={board.id} className={styles.RevisionItemWrapper}>
            <ListItem
              styleClass={styles.showOnHover}
              id={board.revision}
              key={board.id}
              title={"Revision " + board.revision || "NA"}
              onRowItemClick={() => onRevisionClick(board.id)}
              opened={ioConfig.openedRows.standardBoards.includes(board.id)}
            >
              {nodesHolder && (
                <div className={styles.StandardBoardsListChildChild}>
                  <List> {nodesHolder}</List>
                </div>
              )}
            </ListItem>
          </div>
        );
      });
    }

    return (
      <div key={key} className={styles.BoardTypeItemWrapper}>
        <ListItem
          styleClass={styles.showOnHover}
          id={key}
          key={key}
          title={parseEnumStart(key, 2) + " Boards"}
          onRowItemClick={() => onBoardTypeClick(key)}
          opened={ioConfig.openedRows.standardBoardTypes.includes(key)}
        />
        {revisions && (
          <div className={styles.StandardBoardsListChild}>
            <List> {revisions}</List>
          </div>
        )}
      </div>
    );
  });

  return (
    <div className={styles.StandardBoardsListParent}>
      <List>{boardTypes}</List>
    </div>
  );
};

const mapStateToProps = (state: State.Root) => ({
  ioConfig: state.ioConfig
});

export default connect(mapStateToProps)(StandardBoardsList);
